export interface HttpHeaderEntry {
  header: string;
  value: string;
}

export interface BootstrapInterface {
  prefixes?: [string];
  redirectUrl?: {
    login: string,
    logout: string
  };
}

export interface ConfInterface {
  api: {
    headers: HttpHeaderEntry[]
  };

  bootstrap: {
    sso: BootstrapInterface,
    epaper: BootstrapInterface,
    bvz: BootstrapInterface
  };
}

export const Conf: ConfInterface = {
  api: {
    headers: [{header: 'Content-Type', value: 'application/json'}]
  },
  bootstrap: {
    sso: {},
    epaper: {
      prefixes: ['stat_'],
      redirectUrl: {
        login: 'https://epaper.staatsanzeiger.de/edition-sta?token=',
        logout: 'https://sso.staatsanzeiger.de/'
      }
    },
    bvz: {
      redirectUrl: {
        login: 'https://bvz.staatsanzeiger.de/bvz/?token=',
        logout: 'http://bvz.staatsanzeiger.de/'
      }
    }
  }
};
